<template>
  <div>
    <div class="text-xs-right">
      <div>
        <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
      </div>
      <div>
        <v-layout row wrap class="pa-0 ma-0">
          <v-flex xs12>
            <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
            <v-btn :loading="exportloading" color="grey" outline @click="exportxlsx">
              <em class="fas fa-file-export" />
              &nbsp; Export&nbsp;
            </v-btn>
            <v-btn depressed color="primary" @click="addStore">ADD</v-btn>
            <v-btn depressed color="primary" @click="DeleteAllStores">Delete All</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-pagination
      v-model="pageNumber"
      :total-visible="15"
      :length="pagelength"
      @input="changePage"
    ></v-pagination>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>
            {{ props.item.store_id }}
          </td>
          <td>
            {{ props.item.store_name }}
          </td>
          <td>
            {{ props.item.store_area }}
          </td>
          <td class="text-xs-right">
            <v-btn icon @click="editStore(props.item)"> <v-icon>edit</v-icon></v-btn>
            <v-btn icon @click="deleteStore(props.item)"> <v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-dialog v-model="showEdit" persistent width="550px">
        <v-card v-if="showEdit">
          <BranchEdit
            :edittype="edittype"
            :editdata="editdata"
            @onsave="onsave"
            @close="showEdit = false"
          ></BranchEdit>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('รหัสร้านค้า') }}</label>
                <input v-model="filter.storeId" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('ชื่อร้านค้า') }}</label>
                <input v-model="filter.storeName" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('พื้นที่') }}</label>
                <input v-model="filter.StoreArea" class="form-control" type="text" />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="branchReceiptDialog" width="700px" persistent>
      <v-card v-if="branchReceiptDialog">
        <BranchReceipt @close="branchReceiptDialog = false"></BranchReceipt>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import BranchEdit from './BranchEdit.vue'
import BranchReceipt from './BranchReceipt.vue'
import VueQr from 'vue-qr'
import XLSX from 'xlsx'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  components: {
    BranchEdit,
    VueQr,
    importxlsx,
    exportxlsx,
    BranchReceipt
  },
  data() {
    return {
      branchReceiptDialog: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'store_id' },
      columnName: '',
      items: [],
      filter: {
        storeId: '',
        storeName: '',
        storeArea: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'Store No.', value: 'store_id' },
        { text: 'Store Name', value: 'store_name' },
        { text: 'Area', value: 'store_area' },
        { text: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getStore()
  },
  methods: {
    deleteStore(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then(async (result) => {
          if (result.value) {
            this.loading = true
            var data = {
              id: item.id,
              campaign_id: this.$store.state.selectToaCampaign
                ? this.$store.state.selectToaCampaign.id
                : null,
              page_id: this.selectedBot.pageid,
              pageid: this.selectedBot.pageid
            }

            if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
              try {
                await toaMegapaintApi.deleteStore(data)
                this.getStore()
                this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              } catch (error) {
                console.error(error)
              } finally {
                this.loading = false
              }
            } else {
              api.deleteStoreToaecoupon(data, (err, response) => {
                this.loading = false
                if (response.responsecode == 200) {
                  this.getStore()
                  this.$swal.fire({
                    type: 'success',
                    text: 'สำเร็จ'
                  })
                }
              })
            }
          }
        })
    },
    clearsearch() {
      this.filter = {
        storeId: '',
        storeName: '',
        storeArea: ''
      }
      this.getStore()
      this.showsearch = false
    },
    onsearch() {
      this.getStore()
      this.showsearch = false
    },
    async exportxlsx() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        store_id: this.filter.storeId,
        store_name: this.filter.storeName,
        store_area: this.filter.storeArea,
        limit: this.total,
        offset: this.offset,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.exportloading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          const response = await toaMegapaintApi.getStore(data)
          const exporteddata = response.data.data

          const json = exporteddata.map((el) => {
            return {
              Customer: el.store_id,
              'Customer no. Name': el.store_name,
              Area: el.store_area
            }
          })

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedbranch' + '.xlsx')
          this.exportloading = false
        } catch (error) {
          console.error(error)
        } finally {
          this.exportloading = false
        }
      } else {
        api.getStoreToaecoupon(data, (err, response) => {
          var exporteddata = response.data

          var json = exporteddata.map((el) => {
            return {
              Customer: el.store_id,
              'Customer no. Name': el.store_name,
              Area: el.store_area
            }
          })

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedbranch' + '.xlsx')
          this.exportloading = false
        })
      }
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0],
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      api.importStoreToaecoupon(data, async (err, response) => {
        this.importloading = false
        if (response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          this.getStore()
        } else {
          await this.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getStore()
      }
    },
    editStore(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getStore()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },

    addStore() {
      this.edittype = 'create'
      this.showEdit = true
    },
    async getStore() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        store_id: this.filter.storeId,
        store_name: this.filter.storeName,
        store_area: this.filter.storeArea,
        limit: this.limit,
        offset: this.offset,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.loading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          let response = await toaMegapaintApi.getStore(data)
          response = response.data
          this.items = response.data
          this.total = response.total
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        api.getStoreToaecoupon(data, (err, response) => {
          this.loading = false
          this.items = response.data
          this.total = response.total
        })
      }
    },
    DeleteAllStores() {
      this.$store.dispatch('loading')
      var data = {
        pageid: this.selectedBot.pageid,
        page_id: this.selectedBot.pageid,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      api.TOAECOUPONDeleteAllStores(data, (err, response) => {
        this.$store.dispatch('loading')
        this.getStore()
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Branch.vue